import { createContext } from "react";

import { defaultBrazeOperatorContext } from "./constants";
import type { BrazeOperatorContextType } from "./types";

/**
 * Context for enabling operator mode in a subtree of components.
 *
 * When `isOperatorEnabled` is true, operator-aware components
 * (like BrazeButton, BrazeColorPicker, etc.) will render their
 * enhanced versions with Operator support.
 *
 * This allows selectively enabling operator functionality for
 * specific parts of the dashboard without needing to update
 * all consumers of a component.
 *
 * @example
 * // Enable operator mode for SMS composer's NameDescription
 * <BrazeOperatorProvider enabled={true}>
 *   <NameDescription />
 * </BrazeOperatorProvider>
 *
 * @example
 * // Enable operator mode based on a feature flipper
 * <BrazeOperatorProviderWithFeatureFlipper feature="sms_operator_mode">
 *   <NameDescription />
 * </BrazeOperatorProviderWithFeatureFlipper>
 */
export const BrazeOperatorContext = createContext<BrazeOperatorContextType>(defaultBrazeOperatorContext);
